import React, { useState, useEffect } from 'react';
import { ThemeProvider,Confirm,ConfirmWrapper,ConfirmContent } from '@workboard/wobo-ui';
import './compliance.scss';
import UserServices from '../../../services/user.services';
import DOMPurify from 'dompurify';

import styled from "styled-components"
const StyledConfirm = styled(Confirm)`
  ${ConfirmWrapper} {
    width: 500px;
    min-height: 400px;
    max-height: 400px;
    header {
        display: none !important;
    }
  }
  ${ConfirmContent} { 
    padding-top: 24px !important;
    overflow-y: auto;
    max-height: 320px;
    ul {
        list-style-type: disc;
        padding-left: 1.5em;
    }
    b {
        > * {
            font-weight: bold;
        }
    }
  }
  ${ConfirmContent} + div {
      padding-top: 16px !important;
  }
`;

type ComplianceAggrementProps = {
    isOpen: boolean,
    content: string,
}

const ComplianceAggrement = (props: ComplianceAggrementProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);

    const ComplianceData = () => {
        return (
            <div className="compliance-data">
                <div className="compliance-data-content" id="complianceData" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.content)}} />
            </div>
        );
    }

    const setOK = () => {
        const userServices = new UserServices();
        userServices.pushEventForUser({ type: 'COMPLIANCE_MESSAGE_ACCEPTED' });
        userServices.pushEventForUser({ type: 'onetimeLogin' });
        setIsOpen(false);
        setTimeout(() => {
            const focusEl = $("#skip-link-nav")
            if (focusEl) focusEl.focus()
        }, 0)
    }

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            const userServices = new UserServices();
            userServices.pushEventForUser({ type: 'COMPLIANCE_MESSAGE_SHOWN' });
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isOpen])

    return ( isOpen && (
        <ThemeProvider>
            <StyledConfirm
                aria-label="Compliance Agreement and Acknowledgement"
                isOpen={isOpen}
                onSubmit={() => setOK()}
                submitOnly={true}
                submitLabel="I Accept"
                className="complianceBgn"
            >
                <ComplianceData />
            </StyledConfirm>
        </ThemeProvider>
    ));
}

export default ComplianceAggrement;